<div class="tag-input-wrapper">

    <div class="tag-input-container">
        <input type="text" [formControl]="inputControl" [placeholder]="placeholder" [disabled]="disabled"
            (keyup.enter)="addTag()" (blur)="onInputBlur()" class="tag-input" />
    </div>

    <div class="option-input-click" *ngIf="hasInput && !disabled" (click)="addTag()">
        {{ inputControl.value }}
    </div>

    <div class="tags-container" *ngIf="tags.length > 0">
        <button type="button" class="tag-item" *ngFor="let tag of tags; let i = index" (click)="removeTag(i)"
            [disabled]="disabled">
            {{ tag }}
            <img src="assets/icons/close-cross-icon.webp" alt="Remove tag" />
        </button>
    </div>

    <div class="error-message" *ngIf="error && errorMessage">
        {{ errorMessage }}
    </div>
</div>